import { Star, Phone } from "lucide-react";
import { BIZ } from "../data/site";
import { LeaveReview } from "../components/Social";
import { Seo } from "../components/Seo";

export default function Review() {
  return (
    <section className="bg-slate-50 py-20 md:py-28" data-testid="review-page">
      <Seo title={`Leave a review | ${BIZ.name}`} description="Thanks for choosing Good Home Improvement LLC. Leave us a quick Google review." path="/review" noindex />
      <div className="wrap">
        <div className="mx-auto max-w-xl rounded-2xl bg-white p-8 text-center shadow-sm ring-1 ring-slate-200 md:p-10">
          <div className="flex justify-center gap-1">{[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-7 w-7 fill-[#fbbc04] text-[#fbbc04]" />)}</div>
          <h1 className="font-display mt-6 text-4xl font-black uppercase leading-[0.9] text-slate-900 sm:text-5xl">Thanks for choosing us</h1>
          <p className="mt-5 text-sm text-slate-600 md:text-base">Happy with your new roof, siding or gutters? A quick Google review helps your Milwaukee neighbors find a crew they can trust. It takes about a minute.</p>
          <LeaveReview testid="review-page-google-button" className="mt-8 px-6 py-3 text-base" />
          <p className="mt-8 text-sm text-slate-500">Something not right? Call us first and we'll make it right.</p>
          <a href={`tel:${BIZ.phone}`} className="mt-2 inline-flex items-center gap-2 font-semibold text-slate-900 underline underline-offset-2" data-testid="review-page-call"><Phone className="h-4 w-4" /> {BIZ.phone}</a>
        </div>
      </div>
    </section>
  );
}
